import React from "react";

const MiniCard = function(props)
{
    return (

        <div>            
            <img className="mini_Card" src={props.pic} alt=" Game Info Card"></img>
        </div>
    );
}
export default MiniCard;